export default __webpack_public_path__ + "static/media/spa-image-05.c28603a6.png";